import { Exception } from '@/redux/slices/slice_types';
import { findandFormatUTCDateInString, getAgeFromDate } from '@/_utils/date';
import DateTimeDisplay from '@/components/_common/DateTimeDisplay';
import { AssigneeSelect, Notes, PolarisIcon, TableStatus } from '@/exports/columnCommonComponents';
import ExceptionReferenceId from '@/components/Exceptions/References/ExceptionReferenceId';
import ExceptionSeverity from '@/components/Exceptions/ExceptionSeverity';
import ExceptionEnumMap from './ExceptionEnumMap';
import ExceptionsOverflow from './ExceptionOverflow';
import { Tooltip } from '@mui/material';

export default {
  hid: {
    label: 'Exception ID',
    sortField: 'hid',
    render: (cell: Exception['hid']) => <strong>{cell}</strong>
  },
  created_at_dateformat: {
    sortField: 'created_at',
    label: 'Created',
    minWidth: 120,
    render: (_cell: Exception['created_at'], row: Exception) => <DateTimeDisplay>{row.created_at}</DateTimeDisplay>
  },
  updated_at: {
    sortField: 'updated_at',
    label: 'Updated',
    minWidth: 120,
    render: (_cell: Exception['updated_at'], row: Exception) => <DateTimeDisplay>{row.updated_at}</DateTimeDisplay>
  },
  created_at: {
    label: 'Age',
    minWidth: 120,
    render: (cell: Exception['created_at']) => getAgeFromDate(cell)
  },
  description: {
    label: 'Description',
    sortField: 'description',
    minWidth: 250,
    render: (cell: Exception['description']) => findandFormatUTCDateInString(cell, true) || '-'
  },
  customer: {
    label: 'Customer',
    minWidth: 180,
    render: (customer: Exception['customer']) => customer?.name
  },
  severity: {
    label: 'Severity',
    sortField: 'severity',
    render: (cell: Exception['severity']) => <ExceptionSeverity severity={cell} />
  },
  type: {
    label: 'Type',
    sortField: 'type',
    render: (cell: Exception['type']) => <ExceptionEnumMap enumRef="type" value={cell} />
  },
  subtype: {
    label: 'Subtype',
    sortField: 'subtype',
    render: (cell: Exception['subtype'], row: Exception) => (
      <div style={{ display: 'flex', alignItems: 'center', columnGap: '.5rem' }}>
        <ExceptionEnumMap enumRef="subtype" value={cell} />
        {row.error_body && (
          <Tooltip title={row.error_body}>
            <PolarisIcon icon="info" />
          </Tooltip>
        )}
      </div>
    )
  },
  reference_id: {
    label: 'Related ID',
    sortField: 'reference_id',
    render: (_: Exception['reference_id'], row: Exception) => <ExceptionReferenceId id={row.reference_id} type={row.reference_type} />
  },
  status: {
    label: 'Status',
    render: (_: Exception['status'], row: Exception) => <TableStatus status={row.status.toLowerCase()} statusReason={row.status_reason} />
  },
  assigned_user: {
    label: 'Assignee',
    render: (cell: Exception['assigned_user'], row: Exception) => (
      <AssigneeSelect update="exception" value={cell} id={row.id} assigns="user" row={row} />
    ),
    width: 200,
    disableSort: true
  },
  notes: {
    label: 'Notes',
    render: (_cell: any, row: Exception) => (
      <div style={{ width: 40, textAlign: 'center' }}>
        <Notes data={row} type="exceptions" override />
      </div>
    ),
    disableSort: true
  },
  overflow: {
    label: '',
    isOverflow: true,
    render: (_cell: any, row: Exception) => <ExceptionsOverflow row={row} />
  }
};
